import { render } from "./CardsDesign.vue?vue&type=template&id=21320930&scoped=true"
import script from "./CardsDesign.vue?vue&type=script&lang=js"
export * from "./CardsDesign.vue?vue&type=script&lang=js"

import "./CardsDesign.vue?vue&type=style&index=0&id=21320930&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend_tr\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21320930"]])

export default __exports__